// eslint-disable-next-line no-unused-vars
import React from 'react';
import { useTrackSearch, useMetaTags, usePagePrefetcher } from 'app/hooks';

// Separate from Gallery component to prevent Gallery re-render on filter panel state change
const GallerySetup = () => {
  useTrackSearch();
  useMetaTags();
  usePagePrefetcher();

  return null;
};

export default GallerySetup;
